import { useTranslation } from "@/hooks/useTranslation"
import { DescriptiveSelect } from "@/molecules/DescriptiveSelect"
import { Form, Rules } from "@/organisms/Form"

export const AdditionalFieldsDetailsSection = () => {
  const { t } = useTranslation()
  const { t: tType } = useTranslation("translation", {
    keyPrefix: "reports.form.fields.reportType"
  })

  return (
    <>
      <Form.Item
        required={false}
        label={tType("label")}
        name="reportType"
        rules={[Rules.getRequiredFieldRule(t)]}
      >
        <DescriptiveSelect
          placeholder={tType("placeholder")}
          values={[
            {
              label: tType("issue.label"),
              description: tType("issue.desc"),
              value: "REPORT_TYPE_ISSUE_SUMMARY"
            },
            {
              label: tType("scope.label"),
              description: tType("scope.desc"),
              value: "REPORT_TYPE_SCOPE_SUMMARY"
            }
          ]}
        />
      </Form.Item>
    </>
  )
}
